const messages = {
    en: {
      subject: "Subject",
      active: "Active",
      questionNumber: "Questions number",
      edit: "Edit",
      delete: "Delete",
    },
    ru: {
        subject: "Предмет",
        active: "Активный",
        questionNumber: "Количество вопросов",
        edit: "Править",
        delete: "Удалить",
    }
  };

  export default messages;